export const getHotelItineraryUrl = (
  itemAddress: string | undefined,
  hotelAddress: string | undefined,
  itemPlaceId?: string,
  hotelPlaceId?: string
): string => {
  if (!itemAddress && !itemPlaceId) return '';
  if (!hotelAddress && !hotelPlaceId) return '';

  const params = new URLSearchParams();
  params.set('api', '1');

  if (hotelAddress) params.set('origin', hotelAddress);
  if (hotelPlaceId) params.set('origin_place_id', hotelPlaceId);

  if (itemAddress) params.set('destination', itemAddress);
  if (itemPlaceId) params.set('destination_place_id', itemPlaceId);

  return `https://www.google.com/maps/dir/?${params.toString()}`;
};

export const getDirectionsUrl = (address: string, placeId?: string): string => {
  const params = new URLSearchParams();
  params.set('api', '1');
  params.set('destination', address);
  if (placeId) params.set('destination_place_id', placeId);
  return `https://www.google.com/maps/dir/?${params.toString()}`;
};

export const getGoogleMapsPlaceUrl = (placeId: string): string => {
  return `https://www.google.com/maps/place/?q=place_id:${placeId}`;
};
